/**
 * mp-schematic-hub.js
 * Interactive schematic Stage + Control Tower for Spare Parts Hub.
 */
(function () {
  "use strict";

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function pushDl(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function resolveSvgUrl(manifestUrl, svgRef) {
    if (!svgRef) return null;
    if (/^https?:\/\//i.test(String(svgRef))) return String(svgRef);
    try {
      return new URL(String(svgRef), manifestUrl).href;
    } catch (e) {
      return null;
    }
  }

  function injectSvg(wrap, svgText) {
    wrap.innerHTML = "";
    var parser = new DOMParser();
    var doc = parser.parseFromString(svgText, "image/svg+xml");
    var parseErr = qs("parsererror", doc);
    if (parseErr) {
      wrap.innerHTML =
        '<p class="mp-schematic-hub__stage-placeholder">Could not parse diagram.</p>';
      return null;
    }
    var svg = doc.querySelector("svg");
    if (!svg) {
      wrap.innerHTML =
        '<p class="mp-schematic-hub__stage-placeholder">Invalid SVG document.</p>';
      return null;
    }
    wrap.appendChild(svg);
    return svg;
  }

  function hotspotEl(svg, vectorId) {
    if (!vectorId) return null;
    var id = String(vectorId).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    return svg.querySelector("[id=\"" + id + "\"]");
  }

  function applyHotspots(svg, parts, onLeave) {
    (parts || []).forEach(function (p) {
      if (!p || !p.vector_id) return;
      var el = hotspotEl(svg, p.vector_id);
      if (!el) return;
      el.setAttribute("data-mp-hotspot", p.vector_id);
      el.setAttribute("tabindex", "0");
      el.setAttribute("role", "button");
      el.addEventListener("pointerleave", onLeave);
    });
  }

  function initHub(hub) {
    var wrap = qs("[data-mp-stage-svgwrap]", hub);
    if (!wrap) return;

    var tooltip = qs("[data-mp-tooltip]", hub);
    var quickbuy = qs("[data-mp-quickbuy]", hub);
    var backdrop = qs("[data-mp-sheet-backdrop]", hub);
    var btns = qsa("[data-mp-system-btn]", hub);
    if (!btns.length) return;

    var partsMap = {};
    var loadedManifestUrl = null;
    var engaged = false;

    var activeBtn =
      btns.find(function (b) {
        return b.getAttribute("aria-pressed") === "true";
      }) || btns[0];

    function setTowerActive(btn) {
      activeBtn = btn;
      btns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("mp-schematic-hub__tower-btn--active", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    function showTooltip(text, x, y) {
      if (!tooltip || !text) return;
      tooltip.textContent = text;
      tooltip.hidden = false;
      var pad = 14;
      var tw = 260;
      var left = Math.max(8, Math.min(x + pad, window.innerWidth - tw));
      var top = Math.max(8, Math.min(y + pad, window.innerHeight - 56));
      tooltip.style.left = left + "px";
      tooltip.style.top = top + "px";
    }

    function hideTooltip() {
      if (!tooltip) return;
      tooltip.hidden = true;
      tooltip.textContent = "";
    }

    function escAttr(s) {
      return String(s).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }

    function highlight(id) {
      qsa("[data-mp-hotspot].is-highlighted", wrap).forEach(function (n) {
        n.classList.remove("is-highlighted");
      });
      if (!id) return;
      var n = wrap.querySelector("[data-mp-hotspot=\"" + escAttr(id) + "\"]");
      if (n) n.classList.add("is-highlighted");
    }

    function tooltipForPart(part) {
      if (!part) return "";
      var t = part.label || "";
      if (part.sku) t += " (" + part.sku + ")";
      return t;
    }

    function closeQuickbuy() {
      if (!quickbuy) return;
      quickbuy.hidden = true;
      hub.classList.remove("mp-schematic-hub--qb-open");
      highlight(null);
    }

    function populateQuickbuy(part) {
      if (!quickbuy || !part) return;
      var label = qs("[data-mp-qb-label]", quickbuy);
      var skuEl = qs("[data-mp-qb-sku]", quickbuy);
      var priceEl = qs("[data-mp-qb-price]", quickbuy);
      var link = qs("[data-mp-qb-link]", quickbuy);
      var form = qs("[data-mp-schematic-atc-form]", quickbuy);
      var vInput = qs("[data-mp-qb-variant]", quickbuy);
      var atcBtn = qs("[data-mp-schematic-atc-btn]", quickbuy);

      if (label) label.textContent = part.label || "";
      if (skuEl) skuEl.textContent = part.sku || "—";
      if (priceEl) {
        if (part.price) {
          priceEl.textContent = part.price;
          priceEl.hidden = false;
        } else {
          priceEl.textContent = "";
          priceEl.hidden = true;
        }
      }
      if (link) {
        if (part.product_url) {
          link.href = part.product_url;
          link.hidden = false;
        } else {
          link.href = "#";
          link.hidden = true;
        }
      }
      if (form && vInput) {
        if (part.variant_id) {
          vInput.value = String(part.variant_id);
          form.hidden = false;
          if (atcBtn) atcBtn.disabled = false;
        } else {
          vInput.value = "";
          form.hidden = true;
        }
      }
      quickbuy.hidden = false;
      hub.classList.add("mp-schematic-hub--qb-open");
    }

    function onHotspotLeave() {
      hideTooltip();
      highlight(null);
    }

    var ioObserver = null;

    function disconnectIo() {
      if (ioObserver) {
        ioObserver.disconnect();
        ioObserver = null;
      }
    }

    function loadSystem(btn) {
      var url = btn && btn.getAttribute("data-manifest-url");
      if (!url) return Promise.resolve();
      disconnectIo();
      setTowerActive(btn);

      wrap.classList.add("mp-schematic-hub__stage-svgwrap--loading");

      return fetch(url, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("manifest");
          return r.json();
        })
        .then(function (data) {
          var svgRemote = resolveSvgUrl(url, data.svg);
          if (!svgRemote) throw new Error("svg url");
          return fetch(svgRemote, { credentials: "same-origin" }).then(function (sr) {
            if (!sr.ok) throw new Error("svg");
            return sr.text().then(function (svgText) {
              return { data: data, svgText: svgText };
            });
          });
        })
        .then(function (res) {
          loadedManifestUrl = url;
          var svgEl = injectSvg(wrap, res.svgText);
          wrap.classList.remove("mp-schematic-hub__stage-svgwrap--loading");

          partsMap = {};
          (res.data.parts || []).forEach(function (p) {
            if (p && p.vector_id) partsMap[p.vector_id] = p;
          });

          if (svgEl) applyHotspots(svgEl, res.data.parts, onHotspotLeave);

          hideTooltip();
          closeQuickbuy();

          pushDl({
            event: "schematic_loaded",
            schematic_id: (res.data && res.data.schematic_id) || "",
            schematic_group: hub.getAttribute("data-mp-schematic-group") || "",
          });
        })
        .catch(function () {
          wrap.classList.remove("mp-schematic-hub__stage-svgwrap--loading");
          partsMap = {};
          wrap.innerHTML =
            '<p class="mp-schematic-hub__stage-placeholder">Could not load diagram. Try again later.</p>';
        });
    }

    ioObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (activeBtn) loadSystem(activeBtn);
        });
      },
      { rootMargin: "100px", threshold: 0.06 }
    );
    ioObserver.observe(hub);

    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var mu = btn.getAttribute("data-manifest-url");
        if (mu === loadedManifestUrl) {
          var isActive = btn.getAttribute("aria-pressed") === "true";
          if (isActive) return;
        }
        loadSystem(btn);
      });
    });

    wrap.addEventListener(
      "pointerover",
      function (e) {
        var t = e.target.closest("[data-mp-hotspot]");
        if (!t || !wrap.contains(t)) return;
        var id = t.getAttribute("data-mp-hotspot");
        var part = partsMap[id];
        if (part) showTooltip(tooltipForPart(part), e.clientX, e.clientY);
        highlight(id);
        if (!engaged) {
          engaged = true;
          pushDl({
            event: "schematic_hotspot_engaged",
            schematic_group: hub.getAttribute("data-mp-schematic-group") || "",
          });
        }
      },
      true
    );

    wrap.addEventListener(
      "pointermove",
      function (e) {
        if (!tooltip || tooltip.hidden) return;
        var t = e.target.closest("[data-mp-hotspot]");
        if (!t || !wrap.contains(t)) return;
        showTooltip(tooltip.textContent, e.clientX, e.clientY);
      },
      true
    );

    wrap.addEventListener("click", function (e) {
      var t = e.target.closest("[data-mp-hotspot]");
      if (!t || !wrap.contains(t)) return;
      e.preventDefault();
      var id = t.getAttribute("data-mp-hotspot");
      var part = partsMap[id];
      if (!part) return;
      populateQuickbuy(part);
      pushDl({
        event: "schematic_hotspot_click",
        schematic_group: hub.getAttribute("data-mp-schematic-group") || "",
        vector_id: id,
        sku: part.sku || "",
      });
    });

    wrap.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var t = e.target.closest("[data-mp-hotspot]");
      if (!t || !wrap.contains(t)) return;
      e.preventDefault();
      t.click();
    });

    wrap.addEventListener("focusin", function (e) {
      var t = e.target.closest("[data-mp-hotspot]");
      if (!t || !wrap.contains(t)) return;
      var id = t.getAttribute("data-mp-hotspot");
      var part = partsMap[id];
      var rect = t.getBoundingClientRect();
      if (part)
        showTooltip(
          tooltipForPart(part),
          rect.left + rect.width / 2,
          rect.top + rect.height / 2
        );
      highlight(id);
    });

    wrap.addEventListener("focusout", function (e) {
      var t = e.target.closest("[data-mp-hotspot]");
      if (!t || !wrap.contains(t)) return;
      var next = e.relatedTarget;
      if (next && wrap.contains(next) && next.closest("[data-mp-hotspot]")) return;
      onHotspotLeave();
    });

    var qbClose = quickbuy && qs("[data-mp-qb-close]", quickbuy);
    if (qbClose) qbClose.addEventListener("click", closeQuickbuy);
    if (backdrop) backdrop.addEventListener("click", closeQuickbuy);

    var form = quickbuy && qs("[data-mp-schematic-atc-form]", quickbuy);
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = qs("[data-mp-schematic-atc-btn]", form);
        var vEl = qs("[data-mp-qb-variant]", form);
        var vid = vEl && vEl.value;
        if (!vid || !btn) return;
        btn.disabled = true;
        var t0 = btn.textContent;
        btn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }),
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (d) {
                throw new Error((d && d.description) || "Could not add to cart");
              });
            }
            return r.json();
          })
          .then(function () {
            btn.textContent = "Added \u2713";
            btn.classList.add("mp-spares__atc-btn--success");
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            fetch("/cart.js")
              .then(function (x) {
                return x.json();
              })
              .then(function (cart) {
                document.dispatchEvent(
                  new CustomEvent("cart:updated", { detail: { cart: cart }, bubbles: true })
                );
              })
              .catch(function () {});
            setTimeout(function () {
              btn.textContent = t0;
              btn.classList.remove("mp-spares__atc-btn--success");
            }, 2500);
          })
          .catch(function () {
            btn.textContent = "Error";
            btn.classList.add("mp-spares__atc-btn--error");
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = t0;
              btn.classList.remove("mp-spares__atc-btn--error");
            }, 3000);
          });
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && hub.classList.contains("mp-schematic-hub--qb-open")) closeQuickbuy();
    });
  }

  function boot() {
    qsa("[data-mp-schematic-hub]").forEach(initHub);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
